/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionsanswerplaceholder3Inputs */

const en_openquestionsanswerplaceholder3 = /** @type {(inputs: Openquestionsanswerplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type a quick answer the lawyer can read…`)
};

const pt_openquestionsanswerplaceholder3 = /** @type {(inputs: Openquestionsanswerplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escreva uma resposta breve para o advogado ler…`)
};

/**
* | output |
* | --- |
* | "Type a quick answer the lawyer can read…" |
*
* @param {Openquestionsanswerplaceholder3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionsanswerplaceholder3 = /** @type {((inputs?: Openquestionsanswerplaceholder3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionsanswerplaceholder3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionsanswerplaceholder3(inputs)
	return pt_openquestionsanswerplaceholder3(inputs)
});
export { openquestionsanswerplaceholder3 as "openQuestionsAnswerPlaceholder" }